export const PRACTICE = 'practice';
export const EASYPLAY = 'easy';
export const TUTOR = 'tutor';
export const KARAOKE = 'karaoke';

export const MODE_URLS = {
  [PRACTICE]: 'esercizio',
  [EASYPLAY]: 'suona_facile',
  [TUTOR]: 'tutor',
  [KARAOKE]: 'karaoke'
};

export const REVERSE_MODE_URLS = Object.keys(MODE_URLS).reduce((obj, k) => {
  obj[MODE_URLS[k]] = k;
  return obj;
}, {});

export const MODE_LONG_TITLES = {
  [PRACTICE]: 'Esercizio',
  [EASYPLAY]: 'Suona Facile',
  [TUTOR]: 'Tutor',
  [KARAOKE]: 'Karaoke'
};

export const MODE_SHORT_TITLES = {
  [PRACTICE]: 'Esercizio',
  [EASYPLAY]: 'Suona Facile',
  [TUTOR]: 'Tutor',
  [KARAOKE]: 'Karaoke'
};
